import React from "react";
import { useRouter } from "next/router";
import { isMobile, stripPath } from "app/main/functions";

interface IvwData {
    st: string;
    sv: string;
    co: string;
    sc: string;
    xp?: string;
    cp?: string;
}

export enum IvwSubmitMode {
    DOCUMENT_WRITE_MODE = 0,
    APPEND_CHILD_MODE = 1,
    NEW_IMAGE_MODE = 2
}

interface IOM {
    c: (iamData: IvwData, mode: IvwSubmitMode) => void;
}

declare const iom: IOM;

let tracking: IvwData[] | { forEach: undefined; push: (data: IvwData) => void } = [];

function placeIVWScript() {
    const IVWscript = document.createElement("script");
    IVWscript.type = "text/javascript";
    IVWscript.src = "https://stats.t-online.de/include-ivw-agof-szmng-js/id_85433946/tid_js/index_ts585433946.js";
    document.head.appendChild(IVWscript);
    IVWscript.onload = () => {
        const reallySend = (iamData: IvwData) => iom.c(iamData, IvwSubmitMode.APPEND_CHILD_MODE);

        if (tracking.forEach !== undefined) {
            tracking.forEach(reallySend);
        }

        tracking = {
            forEach: undefined,
            push: reallySend
        };
    };
}

const sendIvw = (path: string) => {
    const cp = stripPath(path, 3);
    const st = isMobile() ? "mobtoi" : "toi";
    let ivwData: IvwData;
    if (window.location.href.startsWith("https://www.t-online.de")) {
        ivwData = { st, sv: "in", co: "kommentar", sc: "yes", cp };
    } else {
        ivwData = { st, sv: "in", co: "kommentar", sc: "yes", xp: cp };
    }
    tracking.push(ivwData);
};

export const IVWTagging = () => {
    const router = useRouter();
    const scriptLoading = React.useRef(false);

    React.useEffect(() => {
        if (router) {
            if (!scriptLoading.current) {
                placeIVWScript();
                scriptLoading.current = true;
            }

            sendIvw(router.asPath);
        }
    }, [router && router.asPath]);

    return null;
};
